"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeLocalId = void 0;
/**
 * Removes all non MAQL compatible characters from an identifier by replacing them with an underscore.
 * @param identifier - identifier to sanitize
 * @returns sanitized identifier
 */
function sanitizeLocalId(identifier) {
    return identifier.replace(/[^a-zA-Z0-9_.]/g, "_");
}
exports.sanitizeLocalId = sanitizeLocalId;
//# sourceMappingURL=sanitizeLocalId.js.map